<template>
    <div class="page-count">
        <div class="page-c-main">
            <div class="number-box" v-for="(item, index) in number" :key="index">
                <div class="number">
                    <div class="number-scroll" :style="{top: -(item * 100) + '%'}">
                        <span v-for="num in 10" :class="['num-' + (num - 1)]">{{num - 1}}</span>
                    </div>
                </div>

                <div class="comma" v-if="index !== 0 && (index+1) !== number.length && (index+1)%3 === 0">,</div>
            </div>
        </div>
        <p class="page-c-hint">旋涡当前累计诊断页面数量</p>
        <p class="filing">Copyright ©2017 Xuanwo001 All Rights Reserved <a href="http://www.miitbeian.gov.cn/" target="_blank">粤ICP备09123656号</a></p>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        data() {
            return {
                number: '999999999',
                timeout: null
            }
        },
        created() {
            this.getPageCount();
        },
        beforeDestroy() {
            clearTimeout(this.timeout);
        },
        methods: {
            ...mapActions('check', ['getPageNumber']),
            getPageCount() {
                this.getPageNumber().then(count => {
                    count = count.toString();
                    //小于9位补齐9位
                    let length = 9 - count.length;
                    if (length > 0) {
                        for (let i = 0; i < length; i ++) {
                            count = '0' + count;
                        }
                    }
                    this.number = count;
                    this.timeout = setTimeout(this.getPageCount, 1000 * 60 * 5);
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    $numWidth: 2.8rem;
    $numHeight: 3.2rem;
    .page-count {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        color: #707070;
        text-align: center;
    }
    .page-c-main {
        font-size: 0;
        white-space: nowrap;
    }

    .number-box {
        display: inline-block;
    }

    .number {
        display: inline-block;
        width: $numWidth;
        height: $numHeight;
        margin: 0 5px;
        overflow: hidden;
        background-color: #fff;
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
    }

    .number-scroll {
        position: relative;
        top: 0;
        font-family: "Agency FB", Arial;
        font-size: 2.1rem;
        transition: top 1s ease-out;
    }

    @for $i from 0 through 9 {
        .num-#{$i} {
            display: block;
            height: $numHeight;
            line-height: $numHeight;
        }
    }

    .comma {
        display: inline-block;
        width: 15px;
        height: 45px;
        margin: 0 6px;
        font-size: 36px;
    }
    .page-c-hint {
        font-size: .8rem;
        letter-spacing: 2px;
    }
    .filing {
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        margin: 30px 0 0 0;
        background-color: rgba(31, 31, 32, 0.05);
        &, a {
            color: rgba(51, 51, 51, 0.6);
        }
        a:hover {
            text-decoration: underline;
        }
    }
</style>
<style lang="scss">
    @media screen and (max-height: 700px) {
        .page-count {
            position: relative !important;
            margin-top: 8.4rem;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/index/PageNumber.vue